module.exports = __webpack_public_path__ + "static/media/blog_post.36448e6f.png";